import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export const Section = ({ eyebrow, title, sub, children, className = "", center = true }) => (
  <section className={`relative py-20 sm:py-28 px-5 sm:px-8 ${className}`}>
    <div className="max-w-7xl mx-auto">
      {(eyebrow || title) && (
        <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-14`}>
          {eyebrow && (
            <p data-testid={`eyebrow-${eyebrow.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="text-xs uppercase tracking-[0.25em] font-mono2 font-semibold text-cyan-400 mb-4">
              {eyebrow}
            </p>
          )}
          {title && <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-50 mb-4">{title}</h2>}
          {sub && <p className="text-base text-slate-400 leading-relaxed">{sub}</p>}
        </div>
      )}
      {children}
    </div>
  </section>
);

export const PrimaryLink = ({ to, children, testId, className = "" }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`inline-flex items-center gap-2 rounded-full bg-indigo-500 hover:bg-indigo-400 text-white font-semibold px-7 py-3.5 text-sm transition-colors duration-300 shadow-lg shadow-indigo-500/30 ${className}`}
  >
    {children} <ArrowRight className="w-4 h-4" />
  </Link>
);

export const GhostLink = ({ to, children, testId, className = "" }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`inline-flex items-center gap-2 rounded-full border border-slate-700 hover:border-slate-500 bg-slate-900/60 hover:bg-slate-800/80 text-slate-200 font-semibold px-7 py-3.5 text-sm transition-colors duration-300 ${className}`}
  >
    {children}
  </Link>
);

export const CtaRow = () => {
  const { t } = useLanguage();
  return (
    <div className="flex flex-wrap items-center justify-center gap-4">
      <PrimaryLink to="/signup" testId="cta-start-free">{t("nav.startFree")}</PrimaryLink>
      <GhostLink to="/contact" testId="cta-book-demo">{t("nav.bookDemo")}</GhostLink>
    </div>
  );
};
